import { useQuery } from "react-query";
import {
    GetListInvoicePenyewaResponse,
    ParamsGetListInvoicePenyewa,
} from "../../constants/types";
import axios from "../axios";

const queryString = require("query-string");

const handleRequest = async (params: ParamsGetListInvoicePenyewa) => {
    const apiGetListInvoicePenyewa = queryString.stringifyUrl({
        url: "/api/invoice-sewa",
        query: {
            size: params.size,
            page: params.page,
            search: params.search,
            status: params.status,
            tanggalAwal: params.tanggalAwal,
            tanggalAkhir: params.tanggalAkhir,
        },
    });
    const { data } = await axios.get<GetListInvoicePenyewaResponse>(
        apiGetListInvoicePenyewa,
    );
    return data.data;
};

export default function useInvoicePenyewa(params: ParamsGetListInvoicePenyewa, options?: { enabled?: boolean }) {
    return useQuery<GetListInvoicePenyewaResponse["data"]>(
        ["list-invoice-penyewa", params],
        () => handleRequest(params),
        {
            enabled: options?.enabled ?? true,
        }
    );
}